import React from 'react'

import * as css from './MantenedorHospedajes.css'

import { ModalTrigger, ModalHospedaje } from './Modales.jsx'

export class RowHospedajes extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <tr key={this.props.index}>
                {/* Index */}
                <td className={css.tdIndex}>{this.props.index+1}</td>
                {/* Nombre */}
                <td className={css.tdNombre}>{this.props.hospedaje.nombre}</td>
                {/* Ciudad */}
                <td className={css.tdCiudad}>{this.props.hospedaje.nombreComuna}</td>
                {/* Prioridad */}
                <td className={css.tdPrioridad}>{this.props.hospedaje.prioridad}</td>
                {/* Mail Principal */}
                <td className={css.tdMailPrincipal}>{this.props.hospedaje.mail_principal}</td>
                {/* Telefono Fijo */}
                <td className={css.tdTelefonoFijo}>{this.props.hospedaje.telefono_fijo}</td>
                {/* Celular */}
                <td className={css.tdCelular}>{this.props.hospedaje.celular}</td>
                {/* Celular Wsp */}
                <td className={css.tdCelularWsp}>{this.props.hospedaje.celular_wsp}</td>
                {/* Dirección */}
                <td className={css.tdDireccion}>{this.props.hospedaje.direccion}</td>
                {/* Single Con Baño */}
                <td className={css.tdSingleConBano}>{this.props.hospedaje.single_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                {/* Doble Con Baño */}
                <td className={css.tdDobleConBano}>{this.props.hospedaje.doble_con_bano.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                {/* Acciones */}
                <td className={css.tdAcciones}>
                    <ModalTrigger>
                        {(isVisible, showModal, hideModal)=>
                            <div>
                                <span className="btn btn-xs btn-success glyphicon glyphicon-pencil" onClick={showModal}/>
                                {isVisible && <ModalHospedaje
                                    hideModal={hideModal}
                                    hospedaje={this.props.hospedaje}
                                    nuevo={0}
                                />}
                            </div>
                        }
                    </ModalTrigger>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/proveedores/hospedajes/RowHospedajes.jsx